import React from 'react';

const ExpertiseModal = ({ modalId, title = "Preferred Expertise", expertiseList = [] }) => {
  return (
    <div className="modal fade" id={modalId} data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-hidden="true">
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <ul className="text-secondary text-justify list-group list-group-flush job-desc">
              {expertiseList.map((item, index) => (
                <li key={index} className="list-group-item">
                  <i className="bi bi-cpu-fill"></i>
                  <p>{item}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpertiseModal;
